import { createRouter, createWebHistory } from "vue-router";
import routes from "@/router/routes";

const router = createRouter({
    routes,
    history: createWebHistory(),
})
// 导出
export default router